import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueTipoDocPagar, TTipoDocPagar } from "../../types/api/financeiro/tipos-doc-pagar";

export default function SelectTipoDocPagar({
    value,
    onChange,
    required = false,
    error = false,
    disabled = false,
    extraParams,
    label = "Tipo",
    errorMessage = undefined,
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id ?? ""}${value.nome ? ` - ${value.nome}` : ""}` : ""

    return (
        <>
            <TextField
                {...{ required, error, disabled, label }}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                slotProps={{
                    input: { readOnly: true }
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        title="Selecionar tipo de documento"
                        queryPath="/financeiro/contas-pagar/pesquisar-tipos-documento"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        {...{ handleClose, extraParams }}
                        defaultValue={value || defValueTipoDocPagar}
                        onChange={(value) => {
                            onChange(value as TTipoDocPagar)
                            handleClose()
                        }}
                    />
                </Dialog>
            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TTipoDocPagar
    onChange: (arg: TTipoDocPagar | null) => void
    required?: boolean
    error?: boolean
    disabled?: boolean
    extraParams?: { [key: string]: any };
    label?: string
    errorMessage?: string | undefined
}